import PaymentMethodAddBankDialog from 'components/ui/dialogs/PaymentMethodAddBankDialog';
import PaymentMethodAddCardDialog from 'components/ui/dialogs/PaymentMethodAddCardDialog';
import PaymentMethodAddDialog from 'components/ui/dialogs/PaymentMethodAddDialog';
import Modal from 'components/ui/modal';
import { AnimatePresence } from 'framer-motion';
import { createElement, useCallback, useState } from 'react';
import { Modals, ModalsType } from 'utils/constants';

import AnimatedPage, { AnimationDirection, AnimationDirectionType } from '../modal/AnimatedPage';
import PaymentMethodDialog from './PaymentMethodDialog';

interface Props {
  onClose: () => void;
}

export default function PaymentMethodsDialog({ onClose }: Props) {
  const [headerRef, setHeaderRef] = useState<Element | DocumentFragment | null>(null);
  const [modal, setModal] = useState<ModalsType>(Modals.paymentMethod);
  const [direction, setDirection] = useState<AnimationDirectionType>(AnimationDirection.forward);

  const show = useCallback(
    (modal: ModalsType, back: boolean = false) => {
      setModal(modal);
      setDirection(back ? AnimationDirection.backward : AnimationDirection.forward);
    },
    [setModal, setDirection]
  );

  return (
    <Modal onClose={onClose}>
      <div className='flex flex-col justify-between h-full'>
        <div className='h-[72px] overflow-hidden flex flex-col-reverse'>
          {createElement('div', { ref: setHeaderRef })}
        </div>
        <div className='grow relative'>
          <AnimatePresence custom={direction} initial={false}>
            {modal === Modals.paymentMethod ? (
              <AnimatedPage custom={direction} key='paymentMethod'>
                <PaymentMethodDialog header={headerRef} onAdd={() => show(Modals.pmAdd)} onClose={onClose} />
              </AnimatedPage>
            ) : null}
            {modal === Modals.pmAdd ? (
              <AnimatedPage custom={direction} key='addPaymentMethod'>
                <PaymentMethodAddDialog
                  header={headerRef}
                  onAddBank={() => show(Modals.pmAddBank)}
                  onAddCard={() => show(Modals.pmAddCard)}
                  onBack={() => show(Modals.paymentMethod, true)}
                />
              </AnimatedPage>
            ) : null}
            {modal === Modals.pmAddCard ? (
              <AnimatedPage custom={direction} key='addCard'>
                <PaymentMethodAddCardDialog
                  header={headerRef}
                  onAddCard={() => show(Modals.paymentMethod, true)}
                  onBack={() => show(Modals.pmAdd, true)}
                />
              </AnimatedPage>
            ) : null}
            {modal === Modals.pmAddBank ? (
              <AnimatedPage custom={direction} key='addBank'>
                <PaymentMethodAddBankDialog
                  header={headerRef}
                  onAddBank={() => show(Modals.paymentMethod, true)}
                  onBack={() => show(Modals.pmAdd, true)}
                />
              </AnimatedPage>
            ) : null}
          </AnimatePresence>
        </div>
      </div>
    </Modal>
  );
}
